function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M254.551 155.64c7.466-3.755 14.72-7.926 22.056-11.901 1.62-1.082 3.26-2.176 4.847-3.263 5.974-4.909 11.989-9.761 17.903-14.714 29.434-24.672 50.244-55.009 63.451-90.353 5.822-15.561 9.609-31.404 11.544-47.61L331.627-25.8c-7.026 70.839-43.977 122.656-115.24 151.814-44.983 18.406-118.177 15.428-138.613-2.962 9.497-.642 18.626-1.234 28.913-1.901-10.324-8.719-19.61-16.875-29.288-24.574-2.256-1.817-5.89-3.022-8.8-2.894-20.866.968-41.69 2.356-62.529 3.643-1.916.105-3.774.452-5.924.714 1.56 23.058 3.06 45.627 4.657 68.214.11 1.239.53 2.83 1.427 3.599 10.108 8.78 20.345 17.418 31.528 26.933-1.04-15.977-1.975-30.517-2.96-45.61 2.275 1.079 3.876 1.742 5.414 2.558 20.427 10.774 41.975 18.481 64.846 22.764 52.396 9.793 102.248 2.882 149.493-20.859z",
  fill: "#fff",
  fillOpacity: 0.3
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 191,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrow;